import * as React from 'react';
import { Context } from './Context';

export const useIntegrations = () => React.useContext(Context);
